export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  icon: string;
}

export const categories: Category[] = [
  {
    id: '1',
    name: '最新章节',
    slug: 'latest-chapters',
    description: '第一时间获取秘密教学漫画的最新章节更新信息与抢先解读',
    icon: 'ri-file-copy-2-line',
  },
  {
    id: '2',
    name: '剧情解析',
    slug: 'plot-analysis',
    description: '深入剖析每一话的剧情细节、伏笔设计与叙事技巧',
    icon: 'ri-search-eye-line',
  },
  {
    id: '3',
    name: '角色介绍',
    slug: 'character-intro',
    description: '全面了解秘密教学漫画中各个人物的性格、背景与成长轨迹',
    icon: 'ri-user-star-line',
  },
  {
    id: '4',
    name: '深度评测',
    slug: 'reviews',
    description: '从画风、剧情、人物、主题等多维度对作品进行专业评测',
    icon: 'ri-star-line',
  },
  {
    id: '5',
    name: '合集推荐',
    slug: 'collections',
    description: '精选合集、名场面盘点与经典回顾，一次看过瘾',
    icon: 'ri-stack-line',
  },
];

export const getCategoryBySlug = (slug: string): Category | undefined => {
  return categories.find((c) => c.slug === slug);
};